<template>
    <div class="w100 pl20 pr20 pt20 pb20" v-loading="loading">
        <div>
            <div class="search-warp">
                <el-form :inline="true" label-width="80px">
                        <el-form-item label="用户名" style="width: 230px">
                            <el-input  v-model="formValidate.username" placeholder="请输入用户名" @focus="addPerson" style="width: 150px"></el-input>
                        </el-form-item>
                        <el-form-item label="功能" style="width: 280px">
                            <el-select v-model="formValidate.tion" placeholder="请选择功能" style="width: 200px">
                                <el-option
                                        v-for="item in tionList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary"
                                       size="small"
                                       @click="getTbaleData()"
                                       style="margin-left: 10px" >查 询
                            </el-button>
                            <!--<el-button-->
                                    <!--style="float: right"-->
                                    <!--type="primary"-->
                                    <!--@click="downloadExcel"-->
                                    <!--icon="el-icon-bottom"-->
                                    <!--v-if="userData.routerData.includes('sys_dept_exp') || isAdmin"-->
                            <!--&gt;导出-->
                            <!--</el-button>-->
                        </el-form-item>
                </el-form>
            </div>
            <div class="tableHeight2" style="margin-top: 0">
                <el-table
                        v-loading="tableLoading"
                        :data="deptData.data"
                        stripe
                        @select="handleSelectionChange"
                        tooltip-effect="dark"
                        header-row-class-name="table-head"
                        ref="deptTable"
                >
                    <el-table-column
                            type="index"
                            label="序号"
                            width="65"
                            align="center"
                    ></el-table-column>
                    <el-table-column
                            prop="userName"
                            align="center"
                            label="用户"
                            show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                            prop="remoteAddr"
                            align="center"
                            label="IP"
                            show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                            align="center"
                            label="涉及功能"
                            prop="title"
                    >
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="操作时长"
                            show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{(Number(scope.row.time)/1000)}}
                        </template>

                    </el-table-column>
                </el-table>
            </div>
            <div class="pageDiv">
                <el-pagination
                        background
                        @current-change="changePage"
                        @size-change="handleSizeChange"
                        :current-page="initPage.current"
                        :page-sizes="initPage.sizes"
                        :page-size="initPage.size"
                        layout="total,sizes, prev, pager, next"
                        :total="deptData.total"
                >
                </el-pagination>
            </div>
        </div>
        <importExcel
                ref="uplodModal"
                :uplodData="uplodData"
                @closeUplod="closeUplod"
        ></importExcel>
        <!--选择用户-->
        <charge-person
                ref="personModal"
                :personData="personData"
                @closePerson="closePerson"
        />
    </div>
</template>

<script>
    import importExcel from "@/components/dialog/deptManage/importExcel.vue";
    import  chargePerson from "@/components/management/reportManage/chargePerson.vue";
    import {excelExport} from '@/api/importAndExport/excelApi';
    import {getLogData} from '@/api/personalCenter/personalInfo';
    import {remote} from '@/api/admin/dict';
    import {mapGetters} from "vuex";
    export default {
        name: "operationLog", //操作日志
        components: { importExcel, chargePerson}, //导出组件
        data() {
            return {
                loading: false,
                tableLoading: false,
                formValidate: {
                    username: '',
                    tion: ''
                },
                tionList:[
                    {
                        tionId: '0',
                        tionName: '用户管理'
                    },
                    {
                        tionId: '1',
                        tionName: '用户管理1'
                    },
                    {
                        tionId: '2',
                        tionName: '用户管理1'
                    }
                ],
                deptData: {
                    data: [],
                    total: 0
                },
                initPage: {current: 0, size: 10, sizes: [10, 20, 50, 100]},
                treeSelect: [],
                uplodData: {
                    state: false,
                    type: ""
                },
                selectedId: '',
                currenTreeId: null,
                personData: {
                    userData: [],
                    state: false,
                    disabled: false,
                    data: [],
                    type:'radio'
                }, //用户弹窗组件数据
            };
        },
        computed: {
            ...mapGetters([
                "userData",
            ])
        },
        created () {
        },
        mounted () {
            this.getRemote()
            this.getTbaleData()
        },
        methods: {
            //获取表格数据
            getTbaleData(){
                let params = {}
                if( this.formValidate.tion) {
                     params = {
                         classicType: this.formValidate.tion,
                        uids: this.formValidate.username || '',
                        current: this.initPage.current,
                        size: this.initPage.size
                    }
                }else {
                     params = {
                        uids: this.formValidate.username || '',
                         current: this.initPage.current,
                         size: this.initPage.size
                    }
                }
                getLogData(params).then(({data}) =>{
                    if(data.code == 0) {
                        this.deptData.data = data.data.records || []
                        this.deptData.total = data.data.total
                    }else {
                        this.$message.warning(data.msg||'获取数据异常');
                    }
                }).catch(err=>{
                    this.$message.error( data.msg|| "获取数据异常!" );
                })
            },
            // 获取功能下拉数据
            getRemote(){
                remote('log_classic_type').then(({data}) =>{
                    if(data.code == 0) {
                        this.tionList = data.data
                    }else {
                        this.$message.error(data.msg||'数据异常!')
                    }
                }).catch(err=>{
                    this.$message.error(data.msg||'数据异常!')
                })
            },
            // 展示用户
            addPerson(){
                this.personData.state = true;
                this.$refs.personModal.loadData();
            },
            // 关闭用户选择弹窗并返回所选用户
            closePerson(value){
                if (!value.mans) {
                    this.personData.state = false;
                    return;
                }
                let mans=value.mans||[];
                mans.forEach((item) =>{
                    this.formValidate.username = item.name
                    this.personData.data = [{
                        userId:item.userId,
                        name: item.name
                    }]
                    this.personData.userData = [item.userId]
                })
                this.personData.state = false;
            },
            isAdmin(){
                return (this.userData.roleCodes||[]).includes('ROLE_ADMIN')
            },
            downloadExcel(){
                this.$DownLoad(
                    excelExport('organ'),
                    null,
                    res => {
                        if (res.status == 200) {
                            // this.$message.success("开始下载");
                        } else {
                            this.$alert("下载出错,请稍后重试", "提示", {
                                confirmButtonText: "确定",
                                type: "warning"
                            });
                        }
                    },
                    error => {
                        this.$alert(error, "提示", {
                            confirmButtonText: "确定",
                            type: "warning"
                        });
                    }
                );
            },
            cellClass(row){
                if (row.columnIndex === 0) {
                    return 'disabledCheck'
                }
            },
            handleSelectionChange(selection, row) {
                this.selectedId = selection.length > 0 ? row.deptId : '';
                this.$refs.deptTable.clearSelection();
                if(selection.length > 0) this.$refs.deptTable.toggleRowSelection(row);
            },
            transferFn(row) {
                this.getDeptTreeData(row.deptId)
            },
            delDeptFn(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.moveDeptHttp()
                    } else {
                        return false;
                    }
                });
            },
            uploading() {
                this.uplodData.state = true;
                this.uplodData.type = "organ";
            },
            closeUplod(val) {
                this.uplodData.state = val;
                // this.refreshDepartment(
                //     this.initPage.size,
                //     this.initPage.current,
                //     this.treeSelect != null ? this.treeSelect.id : null
                // );
                this.$store.dispatch("getDeptTree").then((data) => {
                    this.$store.commit("SET_CHOOSE_DEPT",data.data.data)
                });
            },
            /**
             * @description: 分页
             * @param:{num}
             * @return:
             */
            changePage(num) {
                this.initPage.current = num;
                this.getTbaleData()
            },
            /**
             * @description: 选择条数
             * @param:{num}
             * @return:
             */
            handleSizeChange(val) {
                this.initPage.size = val;
                this.initPage.current = 1;
                this.getTbaleData()
            },
        },

    };
</script>

<style lang='less' scoped>
    .container_content {
        display: flex;
        justify-content: space-between;

        .tree {
            max-width: 280px;
            width: auto;
        }

        .main {
            flex: 1;
            min-width: calc(100% - 280px);
        }
    }
    /* 去掉全选按钮 */
    .el-table /deep/.disabledCheck .cell .el-checkbox__inner{
        display:none;
        position:relative;
    }
    .el-table /deep/.disabledCheck .cell:before{
        content:"选择";
        position:absolute;
        right: 11px;
    }
    .select-dept-form{
        padding-bottom: 10px;
    }
    .remark{
        font-size: 14px;
        color: #606266;
        line-height: 26px;
        text-align: left;
        text-indent: 28px;
        padding: 30px 0;
    }
</style>
